
import { Button } from "@/components/ui/button";
import { Users, Calendar as CalendarIcon } from "lucide-react";

interface InterviewHeaderProps {
  onSyncCalendar: () => void;
}

export const InterviewHeader = ({ onSyncCalendar }: InterviewHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-8">
      <div>
        <h1 className="text-4xl font-bold text-gradient">
          Interview Management
        </h1>
        <p className="text-gray-600 mt-2 text-lg">
          Schedule and manage your interviews with potential freelancers
        </p>
      </div>
      <div className="flex gap-4">
        <Button 
          variant="outline"
          className="border-sky-200 text-sky-700 hover:bg-sky-50"
          onClick={onSyncCalendar}
        >
          <CalendarIcon className="w-4 h-4 mr-2" />
          Sync Calendar
        </Button>
        <Button 
          className="bg-gradient-to-r from-sky-500 to-emerald-500 hover:from-sky-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl button-hover"
        >
          <Users className="w-4 h-4 mr-2" />
          Schedule New Interview
        </Button>
      </div>
    </div>
  );
};
